(function($){

  $(document).ready(function(){
    $('.gallery__select').on('change', function(e) {
      const selectedValue = $(this).find(":selected").val();
      window.location.href = selectedValue;
    });
  });

}(jQuery));
